export default "__VITE_ASSET__Dh9RSWsA__"